import type { Me } from '@/api/queries/me/types/me';
import type { QueryClient } from '@tanstack/vue-query';

export default function useUpdateCachedUser(_userProperties: unknown, queryClient: QueryClient) {
  const authUser = (queryClient.getQueryData(['me']) as Me)?.user;

  // Invalidate 'me' query to refetch all user data
  queryClient.invalidateQueries({ queryKey: ['me'] });

  if (authUser?.uuid) {
    // Invalidate the specific user query
    queryClient.invalidateQueries({ queryKey: ['user', authUser.uuid] });
  }
}
